
export class partner {
    /* STATIC */
    public static async init(): Promise<void> {
        new this();
    }

    public constructor(){

    }
}
